import * as Types from '../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type EqVehicleModelDropdownQueryVariables = {};


export type EqVehicleModelDropdownQuery = (
  { __typename?: 'Query' }
  & { eqVehicleModels: Array<(
    { __typename?: 'EqVehicleModelInfo' }
    & Pick<Types.EqVehicleModelInfo, 'type' | 'typeDescription'>
  )> }
);

export type EqVehiclesByLabelQueryVariables = {
  label?: Types.Maybe<Types.Scalars['String']>
};


export type EqVehiclesByLabelQuery = (
  { __typename?: 'Query' }
  & { eqVehiclesByLabel: Array<(
    { __typename?: 'EQVehicle' }
    & Pick<Types.EqVehicle, '_id' | 'id' | 'label' | 'licensePlate' | 'vin' | 'type' | 'derivative'>
  )> }
);

export const EqVehicleModelDropdownDocument = gql`
    query EQVehicleModelDropdown {
  eqVehicleModels {
    type
    typeDescription
  }
}
    `;

    export function useEqVehicleModelDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EqVehicleModelDropdownQuery, EqVehicleModelDropdownQueryVariables>) {
      return ApolloReactHooks.useQuery<EqVehicleModelDropdownQuery, EqVehicleModelDropdownQueryVariables>(EqVehicleModelDropdownDocument, baseOptions);
    };
      export function useEqVehicleModelDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EqVehicleModelDropdownQuery, EqVehicleModelDropdownQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EqVehicleModelDropdownQuery, EqVehicleModelDropdownQueryVariables>(EqVehicleModelDropdownDocument, baseOptions);
      };
      
export type EqVehicleModelDropdownQueryHookResult = ReturnType<typeof useEqVehicleModelDropdownQuery>;
export type EqVehicleModelDropdownQueryResult = ApolloReactCommon.QueryResult<EqVehicleModelDropdownQuery, EqVehicleModelDropdownQueryVariables>;
export const EqVehiclesByLabelDocument = gql`
    query EQVehiclesByLabel($label: String) {
  eqVehiclesByLabel(filter: {label: {REGEX: $label, OPTIONS: "i"}}) {
    _id
    id
    label
    licensePlate
    vin
    type
    derivative
  }
}
    `;

    export function useEqVehiclesByLabelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EqVehiclesByLabelQuery, EqVehiclesByLabelQueryVariables>) {
      return ApolloReactHooks.useQuery<EqVehiclesByLabelQuery, EqVehiclesByLabelQueryVariables>(EqVehiclesByLabelDocument, baseOptions);
    };
      export function useEqVehiclesByLabelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EqVehiclesByLabelQuery, EqVehiclesByLabelQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EqVehiclesByLabelQuery, EqVehiclesByLabelQueryVariables>(EqVehiclesByLabelDocument, baseOptions);
      };
      
export type EqVehiclesByLabelQueryHookResult = ReturnType<typeof useEqVehiclesByLabelQuery>;
export type EqVehiclesByLabelQueryResult = ApolloReactCommon.QueryResult<EqVehiclesByLabelQuery, EqVehiclesByLabelQueryVariables>;